// extracted by mini-css-extract-plugin
export var statistics = "statistics-module--statistics--J-f5L";
export var data = "statistics-module--data--gzLPm";
export var number = "statistics-module--number--3sExs";
export var desc = "statistics-module--desc--5BxLU";
export var image = "statistics-module--image--1HflD";
export var header = "statistics-module--header--1Qz2A";